module.exports = __webpack_public_path__ + "img/pnu_gallery3.5b0a895c.jpg";